import { Badge } from "@/components/ui/badge";
import { CheckCircle2, GraduationCap } from "lucide-react";
import { cn } from "@/lib/utils";

interface CoachBadgeProps {
  isVerified?: boolean;
  size?: "sm" | "md";
  className?: string;
}

export function CoachBadge({ isVerified = false, size = "sm", className }: CoachBadgeProps) {
  const sizeClasses = {
    sm: "text-[10px] px-1.5 py-0.5 gap-0.5",
    md: "text-xs px-2 py-1 gap-1"
  };

  const iconSize = size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5";

  if (isVerified) {
    return (
      <Badge 
        className={cn(
          "font-bold border-2 flex items-center whitespace-nowrap",
          "bg-primary text-primary-foreground border-primary",
          sizeClasses[size],
          className
        )}
      >
        <GraduationCap className={iconSize} />
        HLV
        <CheckCircle2 className={cn(iconSize, "text-primary-foreground")} />
      </Badge>
    );
  }

  return (
    <Badge 
      variant="outline"
      className={cn(
        "font-medium flex items-center whitespace-nowrap",
        "text-purple-500 border-purple-500/50 bg-purple-500/10",
        sizeClasses[size],
        className
      )}
    >
      <GraduationCap className={iconSize} />
      HLV
    </Badge>
  );
}
